/**
 * Runs a task at most once at a time: concurrent callers join the running task instead of starting a second one.
 * The task is forgotten as soon as it settles, so a later call runs it again - a failed run included.
 */
export class SharedTask<T> {
  private promise: Promise<T> | undefined;

  async run(task: () => Promise<T>): Promise<T> {
    this.promise ??= task().finally(() => (this.promise = undefined));
    return this.promise;
  }
}
